import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, Download, Gift, CheckCircle2, Printer, Calendar, BookOpen, Clock, Shield, ChevronDown, ChevronUp } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
const bonusList = [{
  icon: <Printer className="w-4 h-4" data-id="element-84" />,
  name: 'Pack de Plantillas Imprimibles',
  value: '$15.000'
}, {
  icon: <Calendar className="w-4 h-4" data-id="element-85" />,
  name: 'Desafío 7 Días Sin Gritos',
  value: '$12.000'
}, {
  icon: <BookOpen className="w-4 h-4" data-id="element-86" />,
  name: 'El Mapa de la Calma',
  value: '$10.000'
}, {
  icon: <Clock className="w-4 h-4" data-id="element-87" />,
  name: 'Sistema Minimalista',
  value: '$11.000'
}, {
  icon: <Shield className="w-4 h-4" data-id="element-88" />,
  name: 'Protocolo Antirabietas',
  value: '$11.000'
}];
const bonusDetails = [{
  number: 1,
  title: 'Pack de Plantillas Imprimibles',
  value: '$15.000',
  description: '+36 plantillas visuales listas para imprimir y usar. Los niños ven claramente qué deben hacer en cada momento del día.',
  checklist: ['Rutinas de mañana, tarde y noche', 'Tarjetas recortables', 'Tableros personalizables', 'Sistema Primero-Después', 'Adaptadas por edades'],
  image: 'https://cdn.magicpatterns.com/uploads/5CTa398g7wk214PRhY77pC/bono_1.png',
  icon: <Printer className="w-4 h-4" data-id="element-89" />
}, {
  number: 2,
  title: 'Desafío 7 Días Sin Gritos',
  value: '$12.000',
  description: 'Un desafío guiado de 7 días para implementar el sistema paso a paso con acciones de menos de 10 minutos diarios.',
  checklist: ['Introducir rutinas visuales correctamente', 'Reducir conflictos diarios', 'Crear cooperación sin gritos', 'Construir hábitos sostenibles'],
  image: 'https://cdn.magicpatterns.com/uploads/4GQftiZyAKg81uaw52pv2k/bono_2.png',
  icon: <Calendar className="w-4 h-4" data-id="element-90" />
}, {
  number: 3,
  title: 'El Mapa de la Calma',
  subtitle: '5 cuentos para cooperar sin gritos',
  value: '$10.000',
  description: '5 cuentos diseñados para ayudar a los niños a comprender rutinas, emociones y cooperación de manera natural.',
  checklist: ['Entender mejor las rutinas', 'Reducir resistencia al cambio', 'Regular emociones', 'Convertir conflicto en conexión'],
  image: 'https://cdn.magicpatterns.com/uploads/cnSpPWrmy1Sy1amAdDYS2R/bono_3.png',
  icon: <BookOpen className="w-4 h-4" data-id="element-91" />
}, {
  number: 4,
  title: 'Sistema Minimalista',
  subtitle: 'Resultados con 10 minutos al día',
  value: '$11.000',
  description: 'Versión simplificada del método para aplicarse en solo 10 minutos al día. Perfecto para familias ocupadas.',
  checklist: ['Simplificar rutinas familiares', 'Reducir fricción diaria', 'Mantener consistencia sin esfuerzo', 'Aplicar incluso en días ocupados'],
  image: 'https://cdn.magicpatterns.com/uploads/7uYddgivUDx1VvHcioQESB/bono_4.png',
  icon: <Clock className="w-4 h-4" data-id="element-92" />
}, {
  number: 5,
  title: 'Protocolo Antirabietas',
  subtitle: 'Transiciones sin explosiones',
  value: '$11.000',
  description: 'Protocolo práctico para manejar transiciones difíciles (pantallas, salir de casa, dormir) de forma calmada y efectiva.',
  checklist: ['Anticipar transiciones', 'Qué decir cuando se resiste', 'Responder durante rabietas sin perder la calma', 'Recuperar regulación emocional'],
  image: 'https://cdn.magicpatterns.com/uploads/bunSmYt2syXLrroC8PueME/bono_5.png',
  icon: <Shield className="w-4 h-4" data-id="element-93" />
}];
export function FinalCTASection() {
  const [showBonusDetails, setShowBonusDetails] = useState(false);
  return <section id="precio" className="py-12 bg-gradient-to-br from-amber-400 via-yellow-400 to-emerald-400 relative overflow-hidden" data-id="element-94">
      {/* Decorative circles */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-white/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-95"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-emerald-500/20 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-96"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-98">
          <h2 className="text-4xl md:text-6xl font-black text-white mb-2 drop-shadow-sm" data-id="element-99">
            La calma no es suerte.
          </h2>
          <h2 className="text-4xl md:text-6xl font-black text-white mb-8 drop-shadow-sm" data-id="element-100">
            Es diseño.
          </h2>

          <p className="text-xl text-white/90 font-medium mb-8 max-w-2xl mx-auto" data-id="element-101">
            Si quieres cambiar el día a día (de verdad, no solo sentirte
            motivado/a por 10 minutos):
          </p>

          <div className="flex flex-col items-center gap-6 mb-8" data-id="element-102">
            <div className="relative group cursor-pointer" data-id="element-103">
              <div className="absolute -inset-4 bg-white/30 rounded-full blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-104"></div>
              <img src="https://cdn.magicpatterns.com/uploads/3Ex9TPxAeD9F77UaDb1NQA/ChatGPT_Image_3_mar_2026,_10_55_20_p.m..png" alt="Sistema completo Rutinas Visuales sin Gritos" className="w-64 md:w-72 rounded-lg shadow-2xl transform group-hover:scale-105 transition-transform duration-300 relative z-10" data-id="element-105" />
            </div>

            {/* Pricing block with bonuses included */}
            <div className="bg-white/20 backdrop-blur-sm border border-white/40 rounded-3xl px-8 py-8 text-center shadow-xl max-w-md w-full" data-id="element-106">
              <p className="text-white/80 text-sm font-semibold uppercase tracking-widest mb-2" data-id="element-107">
                Precio especial de lanzamiento
              </p>
              <div className="flex items-center justify-center gap-3 mb-1" data-id="element-108">
                <span className="text-white/50 text-2xl font-bold line-through" data-id="element-109">
                  $19.900
                </span>
                <span className="bg-emerald-500 text-white text-sm font-black px-3 py-1.5 rounded-full uppercase tracking-wide shadow-lg shadow-emerald-500/30" data-id="element-110">
                  -50% OFF
                </span>
              </div>
              <div className="flex items-end justify-center gap-1 mb-1" data-id="element-111">
                <span className="text-white text-2xl font-bold mb-1" data-id="element-112">$</span>
                <span className="text-white text-7xl font-black leading-none tracking-tight" data-id="element-113">
                  9.900
                </span>
              </div>
              <p className="text-white/70 text-sm font-medium mb-6" data-id="element-114">
                ARS · Pesos Argentinos
              </p>

              {/* Bonuses included inside pricing */}
              <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-5 text-left mb-6 border-2 border-white/40 relative overflow-hidden" data-id="element-115">
                <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-emerald-400 via-amber-400 to-emerald-400" data-id="element-116"></div>
                <div className="flex items-center gap-2 mb-3 justify-center" data-id="element-117">
                  <Gift className="w-5 h-5 text-white" data-id="element-118" />
                  <span className="text-white font-bold text-sm uppercase tracking-wider" data-id="element-119">
                    5 Bonos Premium incluidos GRATIS
                  </span>
                </div>

                <ul className="space-y-2" data-id="element-120">
                  {bonusList.map((bonus, i) => <li key={i} className="flex items-center gap-3" data-id="element-121">
                      <CheckCircle2 className="w-4 h-4 text-emerald-200 shrink-0" data-id="element-122" />
                      <span className="text-white text-sm flex-1 font-medium" data-id="element-123">
                        {bonus.name}
                      </span>
                      <span className="text-white/70 text-xs line-through font-medium" data-id="element-124">
                        {bonus.value}
                      </span>
                    </li>)}
                </ul>

                <div className="border-t border-white/30 mt-3 pt-3 flex items-center justify-between" data-id="element-125">
                  <span className="text-white/80 text-sm font-medium" data-id="element-126">
                    Valor total bonos:
                  </span>
                  <div className="flex items-center gap-2" data-id="element-127">
                    <span className="text-white/70 text-sm line-through" data-id="element-128">
                      $59.000
                    </span>
                    <span className="text-white font-black text-lg bg-emerald-500/50 px-3 py-0.5 rounded-full" data-id="element-129">
                      GRATIS
                    </span>
                  </div>
                </div>

                <button onClick={() => document.getElementById('bonos')?.scrollIntoView({
                behavior: 'smooth'
              })} className="w-full mt-3 flex items-center justify-center gap-1.5 text-white font-bold text-sm hover:text-white/80 transition-colors cursor-pointer" data-id="element-130">
                  Leer más sobre los bonos
                  <ChevronDown className="w-4 h-4" data-id="element-131" />
                </button>
              </div>

              <button onClick={() => {
              trackAddToCart();
              window.open('https://www.reconectarhoy.com/cart/47864918769899:1', '_blank');
            }} className="w-full px-8 py-5 bg-gradient-to-r from-orange-500 via-red-500 to-pink-500 text-white text-xl font-extrabold rounded-full shadow-[0_0_30px_rgba(239,68,68,0.5)] hover:shadow-[0_0_50px_rgba(239,68,68,0.7)] hover:scale-105 transition-all duration-300 flex items-center justify-center gap-3 group animate-pulse" data-id="element-132">
                <Download className="w-6 h-6" data-id="element-133" />
                Descarga Ahora Sistema Completo
                <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-134" />
              </button>
              <div className="bg-white/20 backdrop-blur-sm border border-white/40 rounded-full px-5 py-2.5 mt-4 inline-flex items-center justify-center gap-2" data-id="element-135">
                <Shield className="w-5 h-5 text-emerald-300" data-id="element-136" />
                <p className="text-white text-sm font-bold" data-id="element-137">
                  Pago seguro con Mercado Pago · Tarjeta, débito o saldo
                  disponible
                </p>
              </div>
            </div>

            <p className="text-white/90 font-medium text-lg" data-id="element-138">
              Empieza con una rutina. Un tablero. Un paso.
            </p>
          </div>

          <div className="inline-block bg-white/20 backdrop-blur-sm px-6 py-2 rounded-full border border-white/30" data-id="element-139">
            <p className="text-white text-sm font-medium" data-id="element-140">
              Ebook digital · Acceso inmediato · Plantillas imprimibles
              incluidas
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}